import React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import UsersContent from "layout/userAdmin/users/UsersContent";
import UserAdminTabs from "layout/userAdmin/UserAdminTabs";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { USER_ADMIN_LICENSE, USER_ADMIN_USERS } from "constants/routes";
import LicenseContent from "layout/userAdmin/license/LicenseContent";
import NavBar from "layout/navbar";
import SideBar from "layout/sidebar";
import { AlertsHolder } from "components/Alert";

const UserAdmin = () => (
  <div className="user_admin">
    <NavBar />
    <SideBar />
    <HashRouter>
      <ModalsHolder />
      <AlertsHolder />
      <UserAdminTabs />
      <Routes>
        <Route path={USER_ADMIN_USERS} element={<UsersContent />} />
        <Route path={USER_ADMIN_LICENSE} element={<LicenseContent />} />
        <Route path="*" element={<Navigate to={USER_ADMIN_USERS} replace />} />
      </Routes>
    </HashRouter>
  </div>
);

export default UserAdmin;
